import type { Uuid } from '@sibe/utilities/common';
import type { HsGeometry } from '../../graphic-engine-new/geometry/geometry.interface';
import type { HsMaterial } from '../../graphic-render-new/materials/material.class';
import { HsGraphicObject } from '../../graphic-render-new/objects/graphic-object.class';
import type { HsToolAction } from './tool-action.class';

export class HsControlTool extends HsGraphicObject {
  constructor(
    uuid: Uuid,
    name: string,
    geometry: HsGeometry,
    material: HsMaterial,
    public readonly action: HsToolAction
  ) {
    super(uuid, name, geometry, material);
  }
}
